"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalRoom = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const Tags_1 = require("../../../cards/Tags");
const DiscardCards_1 = require("../../../deferredActions/DiscardCards");
const DrawCards_1 = require("../../../deferredActions/DrawCards");
class UniversalRoom {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.UNIVERSAL_ROOM;
        this.description = 'Gain 2 M€ for each City tag (max 5). Draw and discard 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.TRANSHUMANS;
        this.currentDelegate = PartyName_1.PartyName.CENTRISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const cityTagCount = Math.min(player.getTagCount(Tags_1.Tags.CITY, 'raw'), 5);
            if (cityTagCount > 0) {
                player.addResource(Resources_1.Resources.MEGACREDITS, cityTagCount * 2, { log: true });
            }
            const influence = turmoil.getPlayerInfluence(player);
            for (let i = 0; i < influence; i++) {
                game.defer(DrawCards_1.DrawCards.keepAll(player));
                game.defer(new DiscardCards_1.DiscardCards(player));
            }
        });
    }
}
exports.UniversalRoom = UniversalRoom;
//# sourceMappingURL=UniversalRoom.js.map